import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Container,
  Typography,
  Grid,
  Box,
  Paper,
  Card,
  CardContent,
  Avatar,
  Chip,
  IconButton,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
  CircularProgress,
  Tooltip
} from "@mui/material";
import {
  ArrowBack,
  Print,
  Download,
  DirectionsCar,
  LocalShipping,
  Person,
  PersonOutline,
  Phone,
  LocationOn,
  Home,
  ContactPhone,
  CheckCircle,
  Description
} from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";

const BookmarkProfile = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const baseUrl = process.env.REACT_APP_BASE_URL;

  // State for all input fields
  const [vehicleType, setVehicleType] = useState("");
  const [customId, setCustomId] = useState("");
  const [ofirstName, setOfirstName] = useState("");
  const [omiddleName, setOmiddleName] = useState("");
  const [olastName, setOlastName] = useState("");
  const [ocontact, setOcontact] = useState("");
  const [odistrict, setOdistrict] = useState("");
  const [oemgContact, setOemgContact] = useState("");
  const [oaddress, setOaddress] = useState("");
  const [vbusinessName, setVbusinessName] = useState("");
  const [vreceiptNo, setVreceiptNo] = useState("");
  const [vvinNo, setVvinNo] = useState("");
  const [vengineNo, setVengineNo] = useState("");
  const [vkNo, setVkNo] = useState("");
  const [vlicensePlate, setVlicensePlate] = useState("");
  const [vvehicleID, setVvehicleID] = useState("");
  const [vcolor, setVcolor] = useState("");
  const [vAddress, setVAddress] = useState("");
  const [vsellerContact, setVsellerContact] = useState("");
  const [vmodel, setVmodel] = useState("");
  const [vpurchasedDate, setVpurchasedDate] = useState("");
  const [opfirstName, setOpfirstName] = useState("");
  const [opmiddleName, setOpmiddleName] = useState("");
  const [oplastName, setOplastName] = useState("");
  const [opContact, setOpContact] = useState("");
  const [opemgContact, setOpemgContact] = useState("");
  const [opdriverLicense, setOpdriverLicense] = useState("");
  const [opAddress, setOpAddress] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [loading, setLoading] = useState(true);

  // States for profile images
  const [ownerProfileImageName, setOwnerProfileImageName] = useState("");
  const [operatorProfileImageName, setOperatorProfileImageName] = useState("");
  const [qrCodeImage, setQrCodeImage] = useState("");

  // Fetch bookmark and users
  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");

      try {
        console.log('Fetching bookmark data for ID:', id);
        console.log('Base URL:', baseUrl);

        // Fetch bookmark data
        const bookmarkResponse = await axios.get(`${baseUrl}/auth/bookmarks/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        console.log('Bookmark response:', bookmarkResponse.data);
        const bookmark = bookmarkResponse.data;

        // Try to fetch users list (optional - only if user has permission)
        try {
          const usersResponse = await axios.get(`${baseUrl}/auth/users`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setUsers(usersResponse.data);
        } catch (userError) {
          console.log('User list not available (no permission):', userError.response?.status);
          setUsers([]); // Set empty array if user doesn't have permission
        }
        setVehicleType(bookmark.vehicleType);
        setCustomId(bookmark.customId);
        setOfirstName(bookmark.ofirstName);
        setOmiddleName(bookmark.omiddleName);
        setOlastName(bookmark.olastName);
        setOcontact(bookmark.ocontact);
        setOdistrict(bookmark.odistrict);
        setOemgContact(bookmark.oemgContact);
        setOaddress(bookmark.oaddress);
        setVbusinessName(bookmark.vbusinessName);
        setVreceiptNo(bookmark.vreceiptNo);
        setVvinNo(bookmark.vvinNo);
        setVengineNo(bookmark.vengineNo);
        setVkNo(bookmark.vkNo);
        setVlicensePlate(bookmark.vlicensePlate);
        setVvehicleID(bookmark.vvehicleID);
        setVcolor(bookmark.vcolor);
        setVAddress(bookmark.vAddress);
        setVsellerContact(bookmark.vsellerContact);
        setVmodel(bookmark.vmodel);
        setVpurchasedDate(bookmark.vpurchasedDate);
        setOpfirstName(bookmark.opfirstName);
        setOpmiddleName(bookmark.opmiddleName);
        setOplastName(bookmark.oplastName);
        setOpContact(bookmark.opContact);
        setOpemgContact(bookmark.opemgContact);
        setOpdriverLicense(bookmark.opdriverLicense);
        setOpAddress(bookmark.opAddress);
        setOwnerProfileImageName(bookmark.ownerProfileImage);
        setOperatorProfileImageName(bookmark.operatorProfileImage);
        setQrCodeImage(bookmark.qrCodeImage);
        setSelectedUser(bookmark.userId);
      } catch (error) {
        console.error("Error fetching bookmark data:", error);
        console.error("Error details:", error.response?.data);
        console.error("Error status:", error.response?.status);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, baseUrl]);

  // Action handlers
  const handleBack = () => {
    navigate('/dashboard/bookmarks');
  };

  const handlePrint = () => {
    window.print();
  };

  const handleDownloadQR = () => {
    if (!qrCodeImage) {
      alert('QR Code not available');
      return;
    }
    const link = document.createElement('a');
    link.href = `${baseUrl}/${qrCodeImage}`;
    link.download = `vehicle-qr-${customId}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (loading) {
    return (
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <CircularProgress size={60} />
        </Box>
      </Container>
    );
  }

  const vehicleTypeDisplay = vehicleType === 1 ? "Motorcycle" : vehicleType === 2 ? "Khekeh" : "Unknown";
  const VehicleIcon = vehicleType === 1 ? DirectionsCar : LocalShipping;

  return (
    <Container maxWidth="xl" sx={{ mt: { xs: 2, sm: 3, md: 4 }, mb: { xs: 2, sm: 3, md: 4 }, px: { xs: 2, sm: 3 } }}>
      <style>{`
        @media print {
          .no-print {
            display: none !important;
          }
          body {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
        }
      `}</style>

      {/* Hero Header Section */}
      <Paper
        className="no-print"
        elevation={3}
        sx={{
          background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
          color: 'white',
          p: { xs: 2, sm: 3, md: 4 },
          borderRadius: 2,
          mb: 3
        }}
      >
        <Grid container spacing={{ xs: 2, md: 3 }} alignItems="center">
          <Grid item xs={12} md={6}>
            <Box>
              <Chip
                icon={<VehicleIcon />}
                label={vehicleTypeDisplay}
                sx={{
                  backgroundColor: 'rgba(255,255,255,0.2)',
                  color: 'white',
                  fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                  height: { xs: 32, sm: 36, md: 40 },
                  mb: 2,
                  '& .MuiChip-icon': { color: 'white' }
                }}
              />
              <Typography variant="h3" fontWeight="bold" gutterBottom sx={{ fontSize: { xs: '1.5rem', sm: '2rem', md: '3rem' } }}>
                {customId || 'N/A'}
              </Typography>
              {vlicensePlate && (
                <Box
                  sx={{
                    display: 'inline-block',
                    backgroundColor: 'white',
                    color: 'black',
                    padding: { xs: '6px 16px', sm: '8px 20px', md: '8px 24px' },
                    borderRadius: 1,
                    border: '3px solid #333',
                    fontFamily: 'monospace',
                    fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' },
                    fontWeight: 'bold',
                    letterSpacing: '0.1em'
                  }}
                >
                  {vlicensePlate}
                </Box>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box display="flex" gap={{ xs: 1, sm: 2 }} justifyContent={{ xs: 'flex-start', md: 'flex-end' }} flexWrap="wrap">
              <Button
                variant="contained"
                startIcon={<ArrowBack />}
                onClick={handleBack}
                
                sx={{ backgroundColor: 'rgba(255,255,255,0.2)', '&:hover': { backgroundColor: 'rgba(255,255,255,0.3)' } }}
              >
                Back
              </Button>
              <Button
                variant="contained"
                startIcon={<Print />}
                onClick={handlePrint}
                
                sx={{ backgroundColor: 'rgba(255,255,255,0.2)', '&:hover': { backgroundColor: 'rgba(255,255,255,0.3)' } }}
              >
                Print
              </Button>
              <Button
                variant="contained"
                startIcon={<Download />}
                onClick={handleDownloadQR}
                disabled={!qrCodeImage}
                
                sx={{ backgroundColor: 'rgba(255,255,255,0.2)', '&:hover': { backgroundColor: 'rgba(255,255,255,0.3)' } }}
              >
                QR Code
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {/* Quick Info Cards */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ minHeight: 120, background: 'linear-gradient(135deg, #2196F3 0%, #64B5F6 100%)', color: 'white' }}>
            <CardContent>
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box>
                  <Typography variant="body2" sx={{ opacity: 0.9 }}>
                    Vehicle Type
                  </Typography>
                  <Typography variant="h5" fontWeight="bold">
                    {vehicleTypeDisplay}
                  </Typography>
                </Box>
                <VehicleIcon sx={{ fontSize: 48, opacity: 0.7 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ minHeight: 120, background: 'linear-gradient(135deg, #4CAF50 0%, #81C784 100%)', color: 'white' }}>
            <CardContent>
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box>
                  <Typography variant="body2" sx={{ opacity: 0.9 }}>
                    Owner
                  </Typography>
                  <Typography variant="h6" fontWeight="bold" noWrap>
                    {`${ofirstName} ${olastName}`}
                  </Typography>
                </Box>
                <Person sx={{ fontSize: 48, opacity: 0.7 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ minHeight: 120, background: 'linear-gradient(135deg, #FF9800 0%, #FFB74D 100%)', color: 'white' }}>
            <CardContent>
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box>
                  <Typography variant="body2" sx={{ opacity: 0.9 }}>
                    Operator
                  </Typography>
                  <Typography variant="h6" fontWeight="bold" noWrap>
                    {opfirstName ? `${opfirstName} ${oplastName}` : 'Not Assigned'}
                  </Typography>
                </Box>
                <PersonOutline sx={{ fontSize: 48, opacity: 0.7 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ minHeight: 120, background: 'linear-gradient(135deg, #9C27B0 0%, #BA68C8 100%)', color: 'white' }}>
            <CardContent>
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box>
                  <Typography variant="body2" sx={{ opacity: 0.9 }}>
                    Registration
                  </Typography>
                  <Typography variant="h6" fontWeight="bold">
                    Active
                  </Typography>
                </Box>
                <CheckCircle sx={{ fontSize: 48, opacity: 0.7 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Owner and Operator Information Row */}
      <Grid container spacing={{ xs: 2, md: 3 }} sx={{ mb: { xs: 2, md: 3 } }}>
        {/* Owner Information */}
        <Grid item xs={12} md={6}>
          <Paper elevation={2} sx={{ p: { xs: 2, sm: 2.5, md: 3 }, borderRadius: 2, height: '100%' }}>
            <Typography variant="h5" color="primary" gutterBottom sx={{ display: 'flex', alignItems: 'center', mb: { xs: 2, md: 3 }, fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
              <Person sx={{ mr: 1 }} />
              Owner Information
            </Typography>
            <Grid container spacing={{ xs: 2, md: 3 }}>
              <Grid item xs={12} sm={4} sx={{ textAlign: 'center' }}>
                {ownerProfileImageName ? (
                  <Box
                    component="img"
                    src={`${baseUrl}/${ownerProfileImageName}`}
                    alt="Owner Profile"
                    sx={{
                      width: { xs: 120, sm: 140, md: 150 },
                      height: { xs: 120, sm: 140, md: 150 },
                      mx: 'auto',
                      boxShadow: 3,
                      border: '4px solid #f0f0f0',
                      borderRadius: 2,
                      objectFit: 'cover'
                    }}
                  />
                ) : (
                  <Box sx={{
                    width: { xs: 120, sm: 140, md: 150 },
                    height: { xs: 120, sm: 140, md: 150 },
                    mx: 'auto',
                    bgcolor: '#4CAF50',
                    fontSize: { xs: '2.5rem', md: '3rem' },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 2,
                    color: 'white',
                    fontWeight: 'bold'
                  }}>
                    {ofirstName?.[0]}
                  </Box>
                )}
              </Grid>
              <Grid item xs={12} sm={8}>
                <Typography variant="h6" gutterBottom fontWeight="bold" sx={{ fontSize: { xs: '1rem', sm: '1.25rem' }, textAlign: { xs: 'center', sm: 'left' } }}>
                  {`${ofirstName} ${omiddleName || ''} ${olastName}`.trim()}
                </Typography>
                <List dense>
                  <ListItem sx={{ flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' } }}>
                    <ListItemIcon sx={{ minWidth: { xs: '100%', sm: '40px' }, mb: { xs: 0.5, sm: 0 } }}><Phone color="primary" /></ListItemIcon>
                    <ListItemText primary="Contact" secondary={ocontact || 'Not provided'} />
                  </ListItem>
                  <ListItem sx={{ flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' } }}>
                    <ListItemIcon sx={{ minWidth: { xs: '100%', sm: '40px' }, mb: { xs: 0.5, sm: 0 } }}><LocationOn color="primary" /></ListItemIcon>
                    <ListItemText primary="District" secondary={odistrict || 'Not provided'} />
                  </ListItem>
                  <ListItem sx={{ flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' } }}>
                    <ListItemIcon sx={{ minWidth: { xs: '100%', sm: '40px' }, mb: { xs: 0.5, sm: 0 } }}><Home color="primary" /></ListItemIcon>
                    <ListItemText primary="Address" secondary={oaddress || 'Not provided'} />
                  </ListItem>
                  <ListItem sx={{ flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' } }}>
                    <ListItemIcon sx={{ minWidth: { xs: '100%', sm: '40px' }, mb: { xs: 0.5, sm: 0 } }}><ContactPhone color="primary" /></ListItemIcon>
                    <ListItemText primary="Emergency Contact" secondary={oemgContact || 'Not provided'} />
                  </ListItem>
                </List>
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* Operator Information */}
        <Grid item xs={12} md={6}>
          <Paper elevation={2} sx={{ p: { xs: 2, sm: 2.5, md: 3 }, borderRadius: 2, height: '100%' }}>
            <Typography variant="h5" color="primary" gutterBottom sx={{ display: 'flex', alignItems: 'center', mb: { xs: 2, md: 3 }, fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
              <PersonOutline sx={{ mr: 1 }} />
              Operator Information
            </Typography>
            <Grid container spacing={{ xs: 2, md: 3 }}>
              <Grid item xs={12} sm={4} sx={{ textAlign: 'center' }}>
                {operatorProfileImageName ? (
                  <Box
                    component="img"
                    src={`${baseUrl}/${operatorProfileImageName}`}
                    alt="Operator Profile"
                    sx={{
                      width: { xs: 120, sm: 140, md: 150 },
                      height: { xs: 120, sm: 140, md: 150 },
                      mx: 'auto',
                      boxShadow: 3,
                      border: '4px solid #f0f0f0',
                      borderRadius: 2,
                      objectFit: 'cover'
                    }}
                  />
                ) : (
                  <Box sx={{
                    width: { xs: 120, sm: 140, md: 150 },
                    height: { xs: 120, sm: 140, md: 150 },
                    mx: 'auto',
                    bgcolor: '#FF9800',
                    fontSize: { xs: '2.5rem', md: '3rem' },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 2,
                    color: 'white',
                    fontWeight: 'bold'
                  }}>
                    {opfirstName?.[0] || 'N'}
                  </Box>
                )}
              </Grid>
              <Grid item xs={12} sm={8}>
                <Typography variant="h6" gutterBottom fontWeight="bold" sx={{ fontSize: { xs: '1rem', sm: '1.25rem' }, textAlign: { xs: 'center', sm: 'left' } }}>
                  {opfirstName ? `${opfirstName} ${opmiddleName || ''} ${oplastName}`.trim() : 'Not Assigned'}
                </Typography>
                <List dense>
                  <ListItem sx={{ flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' } }}>
                    <ListItemIcon sx={{ minWidth: { xs: '100%', sm: '40px' }, mb: { xs: 0.5, sm: 0 } }}><Phone color="primary" /></ListItemIcon>
                    <ListItemText primary="Contact" secondary={opContact || 'Not provided'} />
                  </ListItem>
                  <ListItem sx={{ flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' } }}>
                    <ListItemIcon sx={{ minWidth: { xs: '100%', sm: '40px' }, mb: { xs: 0.5, sm: 0 } }}><ContactPhone color="primary" /></ListItemIcon>
                    <ListItemText primary="Emergency Contact" secondary={opemgContact || 'Not provided'} />
                  </ListItem>
                  <ListItem sx={{ flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' } }}>
                    <ListItemIcon sx={{ minWidth: { xs: '100%', sm: '40px' }, mb: { xs: 0.5, sm: 0 } }}><Description color="primary" /></ListItemIcon>
                    <ListItemText primary="Driver's License" secondary={opdriverLicense || 'Not provided'} />
                  </ListItem>
                  <ListItem sx={{ flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' } }}>
                    <ListItemIcon sx={{ minWidth: { xs: '100%', sm: '40px' }, mb: { xs: 0.5, sm: 0 } }}><Home color="primary" /></ListItemIcon>
                    <ListItemText primary="Address" secondary={opAddress || 'Not provided'} />
                  </ListItem>
                </List>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>

      {/* Vehicle Specifications and QR Code Row */}
      <Grid container spacing={{ xs: 2, md: 3 }}>
        {/* Vehicle Specifications */}
        <Grid item xs={12} md={8}>
          <Paper elevation={2} sx={{ p: { xs: 2, sm: 2.5, md: 3 }, borderRadius: 2, height: '100%' }}>
            <Typography variant="h5" color="primary" gutterBottom sx={{ display: 'flex', alignItems: 'center', mb: { xs: 2, md: 3 }, fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
              <Description sx={{ mr: 1 }} />
              Vehicle Specifications
            </Typography>
            <Box sx={{ display: 'flex', gap: { xs: 2, md: 4 }, flexWrap: 'wrap' }}>
              <Box sx={{ flex: { xs: '1 1 100%', sm: 1 }, borderRight: { xs: 'none', md: '1px solid #e0e0e0' }, pr: { md: 3 }, mb: { xs: 2, md: 0 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, pb: 1, borderBottom: '1px solid #f0f0f0', flexWrap: 'wrap', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" fontWeight="600" sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}>Business Name:</Typography>
                  <Typography variant="body1" fontWeight="500" sx={{ fontSize: { xs: '0.85rem', sm: '1rem' }, textAlign: 'right' }}>{vbusinessName || 'N/A'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, pb: 1, borderBottom: '1px solid #f0f0f0', flexWrap: 'wrap', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" fontWeight="600" sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}>VIN Number:</Typography>
                  <Chip label={vvinNo || 'N/A'} color="primary" variant="outlined" size="small" sx={{ fontSize: { xs: '0.7rem', sm: '0.8125rem' } }} />
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, pb: 1, borderBottom: '1px solid #f0f0f0', flexWrap: 'wrap', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" fontWeight="600" sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}>K No:</Typography>
                  <Typography variant="body1" fontWeight="500" sx={{ fontSize: { xs: '0.85rem', sm: '1rem' } }}>{vkNo || 'N/A'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, pb: 1, borderBottom: '1px solid #f0f0f0', flexWrap: 'wrap', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" fontWeight="600" sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}>Seller Contact:</Typography>
                  <Typography variant="body1" fontWeight="500" sx={{ fontSize: { xs: '0.85rem', sm: '1rem' } }}>{vsellerContact || 'N/A'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, pb: 1, borderBottom: '1px solid #f0f0f0', flexWrap: 'wrap', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" fontWeight="600" sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}>Model:</Typography>
                  <Typography variant="body1" fontWeight="500" sx={{ fontSize: { xs: '0.85rem', sm: '1rem' } }}>{vmodel || 'N/A'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, pb: 1, borderBottom: '1px solid #f0f0f0', flexWrap: 'wrap', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" fontWeight="600" sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}>Purchased Date:</Typography>
                  <Typography variant="body1" fontWeight="500" sx={{ fontSize: { xs: '0.85rem', sm: '1rem' } }}>{vpurchasedDate || 'N/A'}</Typography>
                </Box>
              </Box>

              <Box sx={{ flex: { xs: '1 1 100%', sm: 1 }, pl: { md: 3 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, pb: 1, borderBottom: '1px solid #f0f0f0', flexWrap: 'wrap', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" fontWeight="600" sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}>Receipt No:</Typography>
                  <Typography variant="body1" fontWeight="500" sx={{ fontSize: { xs: '0.85rem', sm: '1rem' } }}>{vreceiptNo || 'N/A'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, pb: 1, borderBottom: '1px solid #f0f0f0', flexWrap: 'wrap', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" fontWeight="600" sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}>Engine No:</Typography>
                  <Chip label={vengineNo || 'N/A'} color="primary" variant="outlined" size="small" sx={{ fontSize: { xs: '0.7rem', sm: '0.8125rem' } }} />
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, pb: 1, borderBottom: '1px solid #f0f0f0', flexWrap: 'wrap', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" fontWeight="600" sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}>License Plate:</Typography>
                  <Box
                    sx={{
                      display: 'inline-block',
                      backgroundColor: '#fff',
                      border: '2px solid #333',
                      borderRadius: 1,
                      padding: { xs: '2px 8px', sm: '4px 12px' },
                      fontFamily: 'monospace',
                      fontSize: { xs: '0.8rem', sm: '1rem' },
                      fontWeight: 'bold'
                    }}
                  >
                    {vlicensePlate || 'N/A'}
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, pb: 1, borderBottom: '1px solid #f0f0f0', flexWrap: 'wrap', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary" fontWeight="600" sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}>Color:</Typography>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Box
                      sx={{
                        width: { xs: 20, sm: 24 },
                        height: { xs: 20, sm: 24 },
                        borderRadius: '50%',
                        backgroundColor: vcolor || '#ccc',
                        border: '2px solid #ddd'
                      }}
                    />
                    <Typography variant="body1" fontWeight="500" sx={{ fontSize: { xs: '0.85rem', sm: '1rem' } }}>{vcolor || 'Not specified'}</Typography>
                  </Box>
                </Box>
              </Box>
            </Box>

            <Divider sx={{ my: { xs: 2, md: 3 } }} />
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, pb: 1, borderBottom: '1px solid #f0f0f0', flexWrap: 'wrap', gap: 1 }}>
              <Typography variant="body2" color="text.secondary" fontWeight="600" sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}>Vehicle Address:</Typography>
              <Typography variant="body1" fontWeight="500" sx={{ textAlign: 'right', maxWidth: { xs: '100%', sm: '70%' }, fontSize: { xs: '0.85rem', sm: '1rem' } }}>{vAddress || 'N/A'}</Typography>
            </Box>
          </Paper>
        </Grid>

        {/* QR Code Section */}
        <Grid item xs={12} md={4}>
          <Paper elevation={2} sx={{ p: { xs: 2, sm: 2.5, md: 3 }, textAlign: 'center', borderRadius: 2, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Typography variant="h5" color="primary" gutterBottom sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
              Vehicle QR Code
            </Typography>
            {qrCodeImage ? (
              <Box>
                <img
                  src={`${baseUrl}/${qrCodeImage}`}
                  alt="QR Code"
                  style={{
                    width: '100%',
                    maxWidth: 200,
                    height: 'auto',
                    objectFit: 'contain',
                    borderRadius: 8,
                    border: '2px solid #ddd',
                    padding: 8,
                    marginTop: 16
                  }}
                />
                <Typography variant="caption" display="block" color="text.secondary" mt={2}>
                  Scan to view vehicle details
                </Typography>
                <Button
                  className="no-print"
                  variant="outlined"
                  startIcon={<Download />}
                  onClick={handleDownloadQR}
                  
                  sx={{ mt: 2 }}
                >
                  Download QR Code
                </Button>
              </Box>
            ) : (
              <Typography color="text.secondary" sx={{ py: 4 }}>
                No QR Code available
              </Typography>
            )}
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default BookmarkProfile;
